import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { CartModal, NavBar } from '@components'
import { BLOCKS_CART_PAGE, BLOCKS_NAV_SPACER_PAGE, VERSION, COMPANY_NAME } from '@common'

export default function MainLayout({ children }) {
    const [isCartModalOpen, setIsCartModalOpen] = useState(false)
    const location = useLocation()

    const _renderCartComponent = () => {
        const isCartHidden = BLOCKS_CART_PAGE.some(page => location.pathname.includes(page))
        if (isCartHidden) return null

        return (
            <CartModal
                isOpen={isCartModalOpen}
                onOpen={() => setIsCartModalOpen(true)}
                onClose={() => setIsCartModalOpen(false)}
            />
        )
    }

    return (
        <div
            className={`dashboard-bg p-0 m-0 ${!BLOCKS_NAV_SPACER_PAGE.some(page => location.pathname.includes(page)) ? 'pt-3' : ''}`}
        >
            <div className="dashboard-page-content">
                <div className="d-flex flex-grow-1 flex-column">
                    <NavBar />
                    {!BLOCKS_NAV_SPACER_PAGE.some(page => location.pathname.includes(page)) && <div style={{ height: 48 }} />}
                    <Outlet />
                    {_renderCartComponent()}
                </div>

                <div className="mt-auto">
                    <div className="text-center text-muted p-4">
                        <p className="mb-0">
                            &copy; {new Date().getFullYear()}，{COMPANY_NAME}
                        </p>
                        <p className="text-muted opacity-50 mb-0 mt-1 no-print">v{VERSION}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
